module.exports = __webpack_public_path__ + "static/media/feature_1_hover.d0ef1a01.jpg";